import React, { FC, useEffect, useState } from "react";
import { useIMask } from "react-imask";
import Input, { InputProps } from "../Input/input";

type MaskedInputProps = Omit<InputProps, "type" | "value" | "onChange"> & {
  value: string;
  onChange: (maskedValue: string) => void;
  maskOptions?: {
    mask: string;
    validate?: (unmaskedValue: string) => boolean;
    placeholderChar?: string;
  };
};

export const MaskedInput: FC<MaskedInputProps> = ({
  value,
  onChange,
  maskOptions,
  ...rest
}) => {
  const [internalError, setInternalError] = useState<boolean>(false);

  const {
    ref: maskRef,
    value: maskedValue,
    setValue,
  } = useIMask(
    {
      mask: maskOptions?.mask,
      lazy: false,
      overwrite: true,
      placeholderChar: maskOptions?.placeholderChar,
    },
    {
      onAccept: (value, maskRef) => {
        if (maskOptions?.validate && maskRef.unmaskedValue) {
          const hasError = maskOptions.validate(maskRef.unmaskedValue);
          if (hasError) {
            setInternalError(true);
            return;
          }
        }

        onChange(value);
        if (internalError) setInternalError(false);
      },
    },
  );

  const setRef = (el: HTMLInputElement | null) => {
    if (el) {
      (maskRef as React.MutableRefObject<HTMLInputElement | null>).current = el;
    }
  };

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, []);

  return (
    <Input
      {...rest}
      ref={setRef}
      type="text"
      value={maskedValue}
      onChange={() => {}}
      hasError={internalError ?? rest.hasError}
    />
  );
};

export default MaskedInput;
